import { Switch } from "antd"
import { campaignStates } from "../types/campaigns"
import { SwitchChangeEventHandler } from "antd/es/switch"

interface ISwitchCampaignState {
  onChange: SwitchChangeEventHandler
  campaignState: campaignStates
}

const SwitchCampaignState: React.FC<ISwitchCampaignState> = ({ onChange, campaignState }) => {
  return (
    <Switch checked={campaignState === campaignStates.ENABLED} onChange={onChange} size="small" />
  )
}

export default SwitchCampaignState
